import { Switch, Box } from "@material-ui/core";
import { Trans } from "react-i18next";
import {WidgetType} from "scenes/cohort-filters/filter-configs/widgetTypes";

export const SwitchRenderer = ({ config, rule, idx, handleUpdateRule }) => (
    <Box key={idx} display="flex" style={{ gap: "10px" }}>
        <Box display="flex" alignItems="center">
            <Trans i18nKey="global.no" />
            <Switch
                checked={config?.getValue ? config?.getValue(rule.properties.value) : rule.properties.value}
                size="small"
                onChange={(e) =>
                    handleUpdateRule(idx, {
                        ...rule.properties,
                        value: config?.setValue ? config?.setValue(e.target.checked) : e.target.checked,
                        //TODO LM: This is horrible, the config shouild be at least come from the fields config
                        widgetType: WidgetType.SWITCH
                    })
                }
                color="primary"
            />
            <Trans i18nKey="global.yes" />
        </Box>
    </Box>
);
